export default __webpack_public_path__ + "static/media/intercom.937a0915.png";